<template>
  <div class="recruitment relative">
    <div style="height: calc(100vh - 114px); overflow: auto;">
      <div class="sub-title px-6 mt-4">
        <span>招募信息</span>
      </div>
      <el-form class="recruitment-form" :model="postForm" :rules="rules" ref="postForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务名称" prop="name">
              <el-input v-model="postForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="问卷题目数">
              <el-input type="number" v-model="postForm.titleAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务截止时间" prop="endAt">
              <el-date-picker
                type="datetime"
                placeholder="请选择日期"
                v-model="postForm.endAt"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报名截止时间">
              <el-date-picker
                type="datetime"
                placeholder="请选择日期"
                v-model="postForm.joinEndAt"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="任务描述" prop="describe">
              <el-input type="textarea" v-model="postForm.describe" maxlength="1000" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="质控标准" prop="qualitySpec">
              <el-input type="textarea" v-model="postForm.qualitySpec" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="结算标准" prop="settleSpec">
              <el-input type="textarea" v-model="postForm.settleSpec" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="sub-row">
          <el-col :span="12" class="sub-title">
            <span>工作地区</span>
          </el-col>
          <el-col :span="12" class="sum-num">
            <span style="color: #948e8e">任务总数量：</span><span>{{ totalNum }}</span>
            <span style="color: #948e8e; margin-left: 20px">任务总价（元）：</span><span>{{ totalPrice }}</span>
          </el-col>
        </el-row>
        <data-table ref="dataTable" :data="tableData" :columns="option.column" :page="page" :index="true" v-if="tableData.length > 0">
          <!-- 工作地区 -->
          <template #name="{ row }">
            <div style="text-align: left">
              <el-select v-model="row.name" placeholder="请选择">
                <el-option v-for="item in workAreaOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </template>
          <!-- 数量 -->
          <template #amount="{ row }">
            <div style="text-align: left">
              <el-input-number
                v-if="isShow"
                style="width: 100%"
                v-model="row.amount"
                controls-position="right"
                @change="handleChange($event, 'amount', row)"
              >
              </el-input-number>
            </div>
          </template>
          <!-- 单价（元） -->
          <template  #price="{ row }">
            <div style="text-align: left">
              <el-input-number
                v-if="isShow"
                style="width: 100%"
                v-model="row.price"
                controls-position="right"
                @change="handleChange($event, 'price', row)"
              >
              </el-input-number>
            </div>
          </template>
          <!-- 备注 -->
          <template #note="{ row }">
            <div style="text-align: left">
              <el-input v-model="row.note"></el-input>
            </div>
          </template>
          <!-- 菜单 -->
          <template #opt="{ row, $index }">
            <el-button type="text" @click="delWorkArea($index)">删除</el-button>
          </template>
        </data-table>
        <div v-else class="empty-text">
          <span>注：点击下方添加工作地区按钮添加工作地区，最少添加1个地区</span>
        </div>
        <div class="add-work mb-6">
          <el-button type="primary" @click="addWorkArea()">添加工作地区</el-button>
        </div>
      </el-form>
    </div>
    <div class="btn-footer h-16 flex items-center justify-end pr-6">
      <el-button @click="onClickCancel()" style="min-width: 88px;">取消</el-button>
      <el-button type="primary" @click="submitForm()">{{ btnSubmit }}</el-button>
    </div>

    <el-dialog width="330px" :title="''" :visible.sync="dialogVisible" @close="confirmDialog" :modal="false">
      <div class="singleBtn">
        <span
          >招募经审核通过后将发布到任务广场， 如有调查员报名可至【报名的{{
            { visitor: '调查员', proxy: '代理' }[pageType]
          }}】页面进行确认和分配任务
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmDialog">确认</el-button>
      </span>
      <div slot="title" style="font-size: 16px"><i class="el-icon-success"></i><span>已发布招募</span></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addRecruitTask,
  editRecruitTask,
  getRecruitTaskDetail,
  addAgencyTask,
  editAgencyTask,
  getAgencyTaskDetail
} from '@/api/wenjuan/offline'
import { cityList } from './cityList'
import DataTable from '@/components/base/DataTable'

export default {
  components: { DataTable },
  props: {
    id: {
      type: Number,
      default: 0
    },
    surveyId: {
      type: [Number, String],
      default: ''
    },
    pageType: {
      type: String,
      default: 'visitor'
    }
  },
  data() {
    return {
      isShow: true,
      dialogVisible: false,
      cityList: cityList,
      btnSubmit: '发布招募', // 发布招募/提交修改
      totalNum: 0,
      totalPrice: 0,
      workAreaOptions: [],
      tableData: [], // 列表data
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },  
      option: {
        column: [
          {
            width: 230,
            label: '工作地区',
            value: 'name',
            slot: true
          },
          {
            width: 160,
            label: '数量',
            value: 'amount',
            slot: true
          },
          {
            width: 160,
            label: '单价（元）',
            value: 'price',
            slot: true
          },
          {
            label: '备注',
            value: 'note',
            slot: true
          },
          {
            label: '操作',
            value: 'opt',
            width: 150
          }
        ]
      },
      rules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { min: 0, max: 1000, message: '最长1000个字符', trigger: 'blur' }
        ],
        endAt: [{ required: true, message: '请选择任务截止时间', trigger: 'change' }],
        describe: [{ required: true, message: '请输入任务描述', trigger: 'blur' }],
        // qualitySpec: [{ required: true, message: '请输入质控标准', trigger: 'blur' }],
        settleSpec: [{ required: true, message: '请输入结算标准', trigger: 'blur' }]
      },
      postForm: {
        name: '',
        titleAmount: '',
        endAt: '',
        joinEndAt: '',
        describe: '',
        qualitySpec: '',
        settleSpec: ''
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    handleChange(val, type, row) {
      let v = (!val || val < 0)? 0 : Number(val)
      if (type == 'price') {
        if (v < 5) {
          this.$message.warning('面访任务单价不能低于5元,请重新输入')
          row.price = 5
        }
      }
      if (type == 'amount') {
        if (v < 1) {
          row.amount = 1
        }
      }
      this.isShow = false
      this.$nextTick(()=>{
        this.isShow = true
      })
      this.sumNum()
    },
    sumNum() {
      this.totalNum = 0
      this.totalPrice = 0
      this.tableData.forEach(i => {
        this.totalNum += i.amount ? Number(i.amount) : 0
        this.totalPrice += i.price ? Number(i.price) * Number(i.amount) : 0
      })
    },
    addWorkArea() {
      this.tableData.push({
        name: '北京市',
        amount: '',
        price: '',
        note: ''
      })
      this.sumNum()
    },
    delWorkArea(index) {
      this.tableData.splice(index, 1)
      this.sumNum()
    },
    submitForm() {
      if (this.tableData.length > 5) {
        this.$message.warning('最多添加五个工作地区！')
        return
      }
      if (this.tableData.length < 1) {
        this.$message.warning('最少添加一个工作地区！')
        return
      }
      let vFlag = false
      this.tableData.forEach(item => {
        if (item.amount == 0 || item.price == 0) {
          vFlag = true
        }
      })
      if (vFlag) {
        this.$message.warning('工作地区的数量和单价不能为0')
        return
      }
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          this.postForm.workArea = this.tableData
          if (this.id) {
            // 修改招募
            this.postForm.id = this.id
            let api = new Function()
            if (this.pageType == 'proxy') {
              api = editAgencyTask
            } else {
              api = editRecruitTask
            }
            api(this.postForm)
              .then(res => {
                if (res.data.code != 0) {
                  this.$message.error(res.data.msg)
                  return
                }
                this.$message.success('修改成功')
                this.resetForm()
                this.onClickCancel()
              })
              .catch(e => {
                this.$message.error(e.message || '修改失败')
              })
          } else {
            // 发布招募
            this.postForm.surveyId = this.surveyId
            let api = new Function()
            if (this.pageType == 'proxy') {
              api = addAgencyTask
            } else {
              api = addRecruitTask
            }
            api(this.postForm)
              .then(res => {
                if (res.data.code != 0) {
                  this.$message.error(res.data.msg)
                  return
                }
                // this.$message.success("发布成功")
                this.dialogVisible = true
              })
              .catch(e => {
                this.$message.error(e.message || '发布失败')
              })
          }
        } else {
          return false
        }
      })
    },
    confirmDialog() {
      this.dialogVisible = false
      this.onClickCancel()
    },
    resetForm() {
      this.$refs['postForm'].resetFields()
      this.tableData = []
    },
    onClickCancel() {
      this.$emit('cancel')
    },
    getRecruitmentInfo() {
      let api = new Function()
      if (this.pageType == 'proxy') {
        api = getAgencyTaskDetail
      } else {
        api = getRecruitTaskDetail
      }
      api({ id: this.id })
        .then(res => {
          let data = res.data.data
          this.postForm = data
          this.tableData = data.workArea
          this.sumNum()
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    getRecruitTaskArea() {
      let array = []
      this.cityList.forEach(item => {
        item.city.forEach(val => {
          array.push({
            value: item.province + val,
            label: item.province + val
          })
        })
      })
      this.workAreaOptions = array
    }
  },
  created() {
    this.getRecruitTaskArea()
    if (this.id) {
      this.btnSubmit = '提交修改'
      this.getRecruitmentInfo()
    } else {
      this.btnSubmit = '发布招募'
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.recruitment-form {
  @apply px-6;
  background-color: #fff;
}
.sub-title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  @apply mb-3;
}
.btn-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.sum-num {
  text-align: right;
}
.empty-text {
  text-align: center;
  margin: 24px 0;
  opacity: 0.45;
  font-size: 14px;
}
.add-work {
  text-align: center;
  margin-top: 20px;
}
.sub-row {
  border-bottom: 1px solid #e7e7eb;
  padding: 5px 0;
}
::v-deep .el-table__fixed,
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
.el-icon-success {
  color: #67c23a;
  margin-right: 6px;
  font-size: 20px;
  position: relative;
  top: 1px;
}
.singleBtn span {
  color: rgb(167, 163, 163);
}
::v-deep .el-input-number--small{ 
  height: unset !important; 
  background-color: #F2F5FA !important;
  color: #6C748A !important;
  .el-input__inner {
    background-color: #F2F5FA !important;
    color: #6C748A !important;
  }
}
</style>
